import React, {Suspense, Fragment, useState, useEffect} from 'react'
import {Button} from "reactstrap";
import DatePicker from "react-datepicker";
import {formatDate, getLeadFieldName, handleErrorResponse, showToast} from "../../Common/Appcommon";
import {faCalendarDays} from "@fortawesome/free-solid-svg-icons/faCalendarDays";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import requestApi from "../../services/requestApi.service";

const TaskActions = (props) => {
    let {actionType, leadId, leadFormname, leadRow, onAfterCreateTask} = props;
    const [isDateOpen, setDateWidgetState] = useState(false);
    const [selectedDate, setSelectedDateValue] = useState("");
    const [taskDesc, setTaskDescription] = useState("");
    const [timing, setTimingData] = useState("");
    let subjectStatus = false;

    const [isSubjectOpen, setSubjectOpen] = useState(subjectStatus);
    const [errors, setErrors] = useState({});

    const chooseTime = async (e, time) => {
        await setTimingData(time);
        setDateWidgetState(false);
        if(actionType === "reminder"){
            setSubjectOpen(false);
            let contactName = leadRow[getLeadFieldName("contactname")];
            await createTaskOrNotes("Reminder: "+contactName, time);
        } else {
            setSubjectOpen(true);
        }
    }
    const handleDatePickerChange = async (selectedDate) =>{
        let scheduledDateTime = formatDate(selectedDate);
        setSelectedDateValue(selectedDate);
        setTimingData(scheduledDateTime);
        await chooseTime(scheduledDateTime);
    }
    const onSelectionEnd = (selectedDate) =>{
        alert(selectedDate);
    }
    const openCustomDateWidget = (e, type) => {
        setDateWidgetState(!isDateOpen);
    }
    const onHandleInputChange = (e) => {
        let value = e.target.value;
        setTaskDescription(value);
    }

    const onTaskSave = async () => {

        await createTaskOrNotes(taskDesc, timing);
    }

    const createTaskOrNotes = async (subject, scheduleTime) => {
        if(subject === ""){
            setErrors({subject: "Title Can't be empty"});
            return;
        }
        let params = {
            "ENTITY": "WHATSAPPPROCESS",
            "OPERATION": "LEAD_MORE_ACTIONS",
            "ACTION": "CREATE_TASK",
            "isOtherApiReq" : true,
            "SUBJECT" : subject,
            "DUEDATE" : scheduleTime,
            "ACTIONTYPE" : actionType,
            "LEADFORMNAME" : leadFormname,
            "LEADID" : leadId
        }
        let response = await requestApi.processServerRequest(params, "Mobile");
        if(response.issuccess) {
            setSubjectOpen(false);
            let successMsg = "";
            if(actionType === "reminder"){
                successMsg = "Reminder created successfully";
            } else if (actionType === "addtask"){
                successMsg = "Task scheduled.";
            } else if (actionType === "addtask"){
                successMsg = "Notes created.";
            }
            showToast(successMsg, "top-right","success");
            onAfterCreateTask();
        } else {
            handleErrorResponse(response.errormsg);
        }
    }
    let textAreaPlaceHolder = "";
    if(actionType === "addtask"){
        textAreaPlaceHolder = "task";
    } else if (actionType === "addnote"){
        textAreaPlaceHolder = "note";
    }
    return (
        <div className={'taskactions'}>
            <div className={'task-button-panel flex mt-3 ml-2'}>
                <Button onClick={(e) => {chooseTime(e, "5_min")}} color="light" className={'mr-1'}>
                    In 5 Mins
                </Button>
                <Button onClick={(e) => {chooseTime(e, "15_min")}}  color="light" className={'mr-1'}>
                    In 15 Mins
                </Button>
                <Button onClick={(e) => {chooseTime(e, "1_hr")}}  color="light" className={'mr-1'}>
                    In 1 Hr
                </Button>
                <div className={'custom-date-selector'}>
                    <DatePicker
                        id={"task_customdate_fieldid"} name={"task_customdate_fieldinput"}
                        popperPlacement="top"
                        onChange={(e) => {
                            handleDatePickerChange(e);
                        }}
                        selected={selectedDate}
                        open={isDateOpen}
                        minDate={new Date()}
                        className={`form-control hide`}
                        showTimeSelect={true}
                        timeFormat="HH:mm"
                        timeIntervals={30}
                        dateFormat="MMMM d, yyyy h:mm aa"
                        timeCaption="Time"
                        onClickOutside={openCustomDateWidget}
                    />
                    <Button onClick={(e) => {openCustomDateWidget(e, "custom")}}  color="light">
                        Custom
                    </Button>
                </div>

            </div>
            <div className={`p-2 pR ${isSubjectOpen ? '' : 'hide'}`}>
                <textarea
                    rows={"5"}
                    name={"tasktitle_fieldinput"}
                    id={"tasktitle_fieldid"}
                    autoComplete={"off"}
                    onChange={(e) => {
                        onHandleInputChange(e);
                    }}

                    placeholder={"Enter "+textAreaPlaceHolder+ " text"}
                    className={`form-control task_description`}
                />
                {errors.subject !== undefined && <em className={`error invalid-feedback`}>{errors.subject}</em> }
                <Button className={"task-creation-button"} disabled={taskDesc === ""} onClick={(e) => {onTaskSave(e)}} outline color="success">
                    <FontAwesomeIcon icon={faCheck}/> Save
                </Button>
            </div>
        </div>
    )
}

export default TaskActions;
